/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_SubtitleInputs */

const en_fc_online_subtitle = /** @type {(inputs: Fc_Online_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore FilmCraft browser editing and choose a hosted editor when available, or follow the web-build setup guide below.`)
};

/**
* | output |
* | --- |
* | "Explore FilmCraft browser editing and choose a hosted editor when available, or follow the web-build setup guide below." |
*
* @param {Fc_Online_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_subtitle = /** @type {((inputs?: Fc_Online_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_subtitle(inputs)
});
export { fc_online_subtitle as "fc.online.subtitle" }